<!-- <div class="personal-info-container"> -->
<app-loading *ngIf="showLoading"></app-loading>
<!-- <div class="personal-info-nav-bar box">
      <div class="personal-info-nav-bar-title">اطلاعات شخصی</div>
      <div class="personal-info-back" (click)="back()">
        <img src="assets/general/back-blue.svg">
      </div>
  </div> -->
<!-- <div class="personal-info-holder box"> -->
<div class="box profile-table">
  <div class="profile-container">
    <p class="profile-cell-title">اطلاعات حساب کاربری</p>
    <div
      *ngFor="let profileTitle of profileTitles; let i = index"
      class="profile-cell"
      [ngStyle]="{
        'margin-top': '0',
        'border-top': i == 0 ? 'none' : '0.5px solid rgb(198, 198, 200)'
      }"
      (click)="openEdit(i)"
    >
      <div class="profile-cell-title">{{ profileTitle }}</div>
      <div class="profile-cell-description">{{ profileValues[i] }}</div>
      <img class="profile-cell-more-icon" src="assets/general/left-black.svg" />
    </div>
  </div>

  <!-- </div> -->
</div>
